import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";
import { OnboardingRoute } from "helper/route";
import RMSRiskAssessment from "pages/JarvisRMS/RMSOnboarding/RMSRiskAssessment";
import RMSCKYC from "pages/JarvisRMS/RMSOnboarding/RMSCKYC";
import RMSPortfolioSync from "pages/JarvisRMS/RMSOnboarding/RMSPortfolioSync";
import RMSOnboardingLayoutContainer from "containers/JarvisRMS/RMSOnboardingLayout";
import RMSOnboardingOverview from "pages/JarvisRMS/RMSOnboardingOverview";

const stageRouteMap = {
  RISK_ASSESSMENT: "/jarvis-rms/onboarding/risk-assessment",
  SYNC_PORTFOLIO: "/jarvis-rms/onboarding/sync-portfolio",
  PLAN_PRICING: "/jarvis-rms/onboarding/plan-pricing",
  CKYC: "/jarvis-rms/onboarding/ckyc",
  DOCUMENT_SIGNING: "/jarvis-rms/onboarding/ckyc",
};

const RMSOnboardingNavigator = (props) => {
  const { match, history } = props;

  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );

  const toCheckIsFirstRender = useSelector((state) => state.master.firstRender);

  const isRMSonboardingCompleted = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.isOnboardingCompleted
  );
  const currentStage = useSelector(
    (state) => state.jarvisRMS.rmsOnboarding.currentStage
  );

  React.useEffect(() => {
    if (toCheckIsFirstRender) return;

    const route = stageRouteMap[currentStage];
    if (route && history.location.pathname !== route) {
      history.replace(route);
    }
  }, [currentStage, toCheckIsFirstRender]);

  return (
    // new code to redirect if any onboarding completed  /customer/dashboard
    // old code to redirect if any onboarding completed  /jarvis-rms/dashboard
    <Switch>
      <RMSOnboardingLayoutContainer {...props}>
        <Switch>
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isRMSonboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/overview`}
            component={RMSOnboardingOverview}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isRMSonboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/risk-assessment`}
            component={RMSRiskAssessment}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isRMSonboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/sync-portfolio`}
            component={RMSPortfolioSync}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isRMSonboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/plan-pricing`}
            component={RMSPortfolioSync}
          />

          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isRMSonboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/ckyc`}
            component={RMSCKYC}
          />
        </Switch>
      </RMSOnboardingLayoutContainer>
    </Switch>
  );
};

export default RMSOnboardingNavigator;
